var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Combobox',{attrs:{"options":_vm.scaleOptions,"label":'N° de zonas a clasificar:',"customValue":_vm.value,"selectorValue":'id',"showCloseBtn":false,"selectorDescription":'value',"noOptionText":'',"placeholder":'Seleccionar'},on:{"selected-option":_vm.handleSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }